module.exports = __webpack_public_path__ + "img/ko_number_03.85ef0c60.svg";